import React, { useState } from 'react';

import { BulbOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';

import { InventiveDrawer } from './InventiveDrawer';

export const InventiveButton = () => {
  // Not using showAsyncModal for now because we need to keep the iframe mounted to preserve sidebar state
  // Will switch back to showAsyncModal when Inventive implements state propagation
  const [showDrawer, setShowDrawer] = useState(false);
  return (
    <>
      <BulbOutlined
        className={css`
          padding: 5px 0;
        `}
        onClick={() => setShowDrawer(true)}
      />
      <InventiveDrawer onClose={() => setShowDrawer(false)} visible={showDrawer} />
    </>
  );
};
